import QuestionUsage from '@/modules/common/common/models/APP/questionnaire/QuestionUsage'
import QuestionDescription from '@/modules/common/common/models/APP/questionnaire/QuestionDescription'
import QuestionPathology from '@/modules/common/common/models/APP/questionnaire/QuestionPathology'
import QuestionAdmission from '@/modules/common/common/models/APP/questionnaire/QuestionAdmission'

export default class LifeInsuredMedicalQuestionnaire {
  private _disability!: QuestionDescription
  private _interruptedActivity!: QuestionAdmission
  private _sickLeave!: QuestionDescription
  private _alcohol!: QuestionUsage
  private _smoking!: QuestionUsage
  private _drugs!: QuestionUsage
  private _medication!: QuestionDescription
  private _injuries!: QuestionPathology

  filled: boolean | null

  constructor(data: Partial<LifeInsuredMedicalQuestionnaire> = {}) {
    this.disability = data.disability
    this.interruptedActivity = data.interruptedActivity
    this.sickLeave = data.sickLeave
    this.alcohol = data.alcohol
    this.smoking = data.smoking
    this.drugs = data.drugs
    this.medication = data.medication
    this.injuries = data.injuries

    this.filled = data.filled ?? null
  }

  get disability(): QuestionDescription {
    return this._disability
  }

  set disability(value: QuestionDescription | undefined) {
    this._disability = new QuestionDescription(value)
  }

  get interruptedActivity(): QuestionAdmission {
    return this._interruptedActivity
  }

  set interruptedActivity(value: QuestionAdmission | undefined) {
    this._interruptedActivity = new QuestionAdmission(value)
  }

  get sickLeave(): QuestionDescription {
    return this._sickLeave
  }

  set sickLeave(value: QuestionDescription | undefined) {
    this._sickLeave = new QuestionDescription(value)
  }

  get alcohol(): QuestionUsage {
    return this._alcohol
  }

  set alcohol(value: QuestionUsage | undefined) {
    this._alcohol = new QuestionUsage({amount:value?.amount, type:value?.type, frequency: 'Diaria'})
  }

  get smoking(): QuestionUsage {
    return this._smoking
  }

  set smoking(value: QuestionUsage | undefined) {
    this._smoking = new QuestionUsage({amount:value?.amount, type:value?.type, frequency: 'Diaria'})
  }

  get drugs(): QuestionUsage {
    return this._drugs
  }

  set drugs(value: QuestionUsage | undefined) {
    this._drugs = new QuestionUsage(value)
  }

  get medication(): QuestionDescription {
    return this._medication
  }

  set medication(value: QuestionDescription | undefined) {
    this._medication = new QuestionDescription(value)
  }

  get injuries(): QuestionPathology {
    return this._injuries
  }

  set injuries(value: QuestionPathology | undefined) {
    this._injuries = new QuestionPathology(value)
  }

  isEmpty() {
    return !this.filled
  }

  updateAttributes(newAttributes: Partial<LifeInsuredMedicalQuestionnaire>) {
    Object.assign(this, newAttributes)
  }
}
